import React, { useState, useEffect } from "react";
import "../styles/Messages2.css"; // Ensure this CSS is updated
import Layout from "../components/layout";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

const Messages = () => {
  const [tickets, setTickets] = useState([]);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [filter, setFilter] = useState({ company_name: "", status: "" });
  const isAdmin = useSelector((state) => state.user.user?.type === "Admin");
  const isAfl = useSelector((state) => state.user.user?.type === "Afl");
  const navigate = useNavigate();

  useEffect(() => {
    fetchTickets();
  }, []);

  const fetchTickets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/auth/tickets`,
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      const result = await response.json();
      if (result.success) {
        setTickets(result.data);
        setFilteredTickets(result.data);
      }
    } catch (error) {
      console.error("Error fetching tickets:", error);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter({ ...filter, [name]: value });
  };

  useEffect(() => {
    const applyFilters = () => {
      const { company_name, status } = filter;
      const filtered = tickets.filter((item) => {
        return (
          (company_name === "" ||
            item.company_name
              .toLowerCase()
              .includes(company_name.toLowerCase())) &&
          (status === "" || item.status === status)
        );
      });
      setFilteredTickets(filtered);
    };

    applyFilters();
  }, [filter, tickets]);

  const formatDate = (dateString) => {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    };
    return new Date(dateString).toLocaleString([], options);
  };

  const getStatusClass = (status) => {
    switch (status) {
      case "open":
        return "status-open";
      case "in-progress":
        return "status-in-progress";
      case "closed":
        return "status-closed";
      default:
        return "";
    }
  };

  const handleTicketClick = (ticket_id) => {
    navigate(`/ticketdetails/${ticket_id}`);
  };

  return (
    <Layout>
      <div className="messages-page px-5 mt-3">
        <div className="global-container">
          {isAdmin && (
            <>
              <div className="tickets-header">
                <div className="d-flex justify-content-center">
                  <h3 className="page-title">Liste Tickets</h3>
                </div>

                <div className="filter-bar">
                  <div className="filter-row">
                    <div className="filter-item">
                      <input
                        type="text"
                        name="company_name"
                        placeholder="Société"
                        value={filter.company_name}
                        onChange={handleFilterChange}
                        className="filter-input"
                      />
                    </div>
                    <div className="filter-item">
                      <select
                        name="status"
                        value={filter.status}
                        onChange={handleFilterChange}
                        className="filter-select"
                      >
                        <option value="">Statut</option>
                        <option value="open">Ouvert</option>
                        <option value="in-progress">En Cours</option>
                        <option value="closed">Fermé</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tickets-container">
                {filteredTickets.map((ticket) => (
                  <div
                    key={ticket.ticket_id}
                    className="ticket-card"
                    onClick={() => handleTicketClick(ticket.ticket_id)}
                  >
                    <div className="ticket-info">
                      <div className="ticket-header">
                        <h3 className="ticket-title">
                          {ticket.category} <br />
                          <span className="company-name">
                            {ticket.company_name}
                          </span>{" "}
                          <br />
                          <span className="ticket-id">
                            Ticket #{ticket.ticket_id}
                          </span>
                        </h3>
                        <p
                          className={`status ${getStatusClass(ticket.status)}`}
                        >
                          Statut:{" "}
                          {ticket.status === "in-progress"
                            ? "En Cours"
                            : ticket.status === "closed"
                            ? "Fermé"
                            : ticket.status === "open"
                            ? "Ouvert"
                            : "En attente"}
                        </p>
                      </div>
                      <p className="ticket-date">
                        Created: {formatDate(ticket.created_at)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}

          {isAfl && (
            <>
              <div className="tickets-header">
                <h1 className="page-title">Support Tickets</h1>
                <div className="filter-bar">
                  <div className="filter-row">
                    <div className="filter-item">
                      <select
                        name="status"
                        value={filter.status}
                        onChange={handleFilterChange}
                        className="filter-select"
                      >
                        <option value="">Statut</option>
                        <option value="Ouvert">Ouvert</option>
                        <option value="En Cours">En Cours</option>
                        <option value="Ferme">Fermé</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div className="tickets-container">
                {filteredTickets.map((ticket) => (
                  <div
                    key={ticket.ticket_id}
                    className="ticket-card"
                    onClick={() => handleTicketClick(ticket.ticket_id)}
                  >
                    <div className="ticket-info">
                      <div className="ticket-header">
                        <h3 className="ticket-title">
                          {ticket.category} <br />
                          <span className="company-name">
                            {ticket.company_name}
                          </span>{" "}
                          <br />
                          <span className="ticket-id">
                            Ticket #{ticket.ticket_id}
                          </span>
                        </h3>
                        <p
                          className={`status ${getStatusClass(ticket.status)}`}
                        >
                          Statut: {ticket.status}
                        </p>
                      </div>
                      <p className="ticket-date">
                        Created: {formatDate(ticket.created_at)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default Messages;
